import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PAExtensions_Header, InvalidMessage } from "../../Utility/Constants";
import { Grid, TextField, Autocomplete } from '@mui/material'
import Button from "@mui/material/Button";
import { Refresh, Search, Clear } from "@mui/icons-material";
import Table from '../../Table/Table';
import { clearAll, getRunDate, getRunDateSeqNo, getCarrier, clearRunIdAndSubq, clearSeqAndSubq, searchTriggered } from '../../Redux/CNS/CommonSlice';
import { currentData, clearData, updateSearch, searchClicked, clearTable, updateInputError, resetError } from '../../Redux/CNS/PAExtensionsSlice';
import { tableColumns } from '../../Redux/TableSlice';
import { PAExtensionsColumns } from '../../Table/TableColumn';
import { getAccessToken } from '../../Redux/TokenSlice';
import Spinner from '../../Spinner/Spinner';
import {
    validateRegexNumbersSpecialChar, validateRegexOnlyNumbers,
    validateRegexWithNumbers, validateRegexWithoutNumbers
} from '../../Validation/Validation';
import { toast } from 'react-toastify';
import { GeneralError } from '../../Utility/Constants';
import { showAll, isMNR } from '../../Redux/MNR/MNRCommonSlice';

function PAExtensions() {
    const dispatch = useDispatch();
    const isSmall = useSelector(state => state.resolution.isSmall);
    const runDate = useSelector(state => state.cnsCommon.runDate);
    const seqNo = useSelector(state => state.cnsCommon.seqNo);
    const carrier = useSelector(state => state.cnsCommon.carrier);
    const data = useSelector(state => state.cnsPAExtensions.data);
    const search = useSelector(state => state.cnsPAExtensions.search);
    const isSearched = useSelector(state => state.cnsPAExtensions.isSearchClicked);
    const searchTriggeredValue = useSelector(state => state.cnsCommon.searchTriggered);
    const loading = useSelector(state => state.cnsCommon.loading);
    const inputError = useSelector(state => state.cnsPAExtensions.inputError);
    const hasAnyError = Object.values(inputError).some(value => value === true);
    const error = useSelector(state => state.cnsPAExtensions.error);
    const errorToken = useSelector(state => state.token.error);
    const commonError = useSelector(state => state.cnsCommon.error);

    useEffect(() => {
        if (error || errorToken || commonError) {
            toast.error(GeneralError);
            return;
        }
    }, [error, errorToken, commonError]);

    const handleResetInitial = (useCallback(() => {
        dispatch(clearAll());
        dispatch(clearData());
        dispatch(updateSearch(true));
        dispatch(searchClicked(false));
        dispatch(showAll(false));
        dispatch(isMNR(false));
    }, [dispatch]))

    const handleReset = () => {
        dispatch(clearData());
        dispatch(updateSearch(true));
        dispatch(searchClicked(false));
    }

    useEffect(() => {
        handleResetInitial();
        dispatch(getAccessToken()).then(() => {
            dispatch(getRunDate("paextension"))
            dispatch(tableColumns(PAExtensionsColumns));
        });
    }, [dispatch, handleResetInitial])

    const handleChange = (name, value) => {
        const val = value.target.value || value.target.innerText;
        dispatch(getAccessToken());
        if (name === 'runId' && value.target.innerText !== '' && value.target.innerText !== undefined) {
            let query = {
                runId: value.target.innerText,
                tab: "paextension"
            }
            dispatch(clearTable(false));
            dispatch(getRunDateSeqNo(query));
        }
        if (name === 'seqNo' && value.target.innerText !== '' && value.target.innerText !== undefined
            && data.runId !== undefined && data.runId !== ''
        ) {
            dispatch(updateSearch(false))
            let query = {
                runId: data.runId,
                seq: value.target.innerText,
                tab: "pa_extension",
            }
            dispatch(clearTable(false));
            dispatch(getCarrier(query));
        }
        if (name === 'carrier') {
            dispatch(clearTable(false));
        }
        switch (name) {
            case 'runId':
                let newDatarunId = {
                    runId: val,
                    seqNo: '',
                    carrier: '',
                    accountInput: '',
                    groupInput: '',
                    memberInput: '',
                    gpiInput: '',
                    totalCount: 0,
                    sortOrder: 'asc',
                    columnName: 'Run Date',
                    pageSize: 50,
                    page: 0,
                    tableData: []
                }
                dispatch(resetError());
                dispatch(currentData(newDatarunId));
                dispatch(clearRunIdAndSubq());
                dispatch(updateSearch(true));
                break;
            case 'seqNo':
                let newDataSeqNo = {
                    runId: data.runId,
                    seqNo: val,
                    carrier: '',
                    accountInput: '',
                    groupInput: '',
                    memberInput: '',
                    gpiInput: '',
                    totalCount: 0,
                    sortOrder: 'asc',
                    columnName: 'Run Date',
                    pageSize: 50,
                    page: 0,
                    tableData: []
                }
                dispatch(resetError());
                dispatch(currentData(newDataSeqNo));
                dispatch(clearSeqAndSubq());
                break;
            case 'carrier':
                let newDataCarrier = {
                    runId: data.runId,
                    seqNo: data.seqNo,
                    carrier: val,
                    accountInput: '',
                    groupInput: '',
                    memberInput: '',
                    gpiInput: '',
                    totalCount: 0,
                    sortOrder: 'asc',
                    columnName: 'Run Date',
                    pageSize: 50,
                    page: 0,
                    tableData: []
                }
                dispatch(resetError());
                dispatch(currentData(newDataCarrier));
                break;
            default:
                switch (name) {
                    case 'accountInput':
                        const updateRegexWithoutNumbersError = validateRegexWithoutNumbers(name, val, inputError);
                        dispatch(updateInputError(updateRegexWithoutNumbersError));
                        break;
                    case 'groupInput':
                        const updateRegexWithNumbers = validateRegexWithNumbers(name, val, inputError);
                        dispatch(updateInputError(updateRegexWithNumbers));
                        break;
                    case 'memberInput':
                        const updateRegexOnlyNumbers = validateRegexOnlyNumbers(name, val, inputError);
                        dispatch(updateInputError(updateRegexOnlyNumbers));
                        break;
                    case 'gpiInput':
                        const updateRegexNumbersSpecialChar = validateRegexNumbersSpecialChar(name, val, inputError);
                        dispatch(updateInputError(updateRegexNumbersSpecialChar));
                        break;
                    default:
                        break;
                }
                const updatedData = {
                    ...data,
                    [name]: val
                };
                dispatch(currentData(updatedData));
                break;
        }
    }

    const handleClear = () => {
        dispatch(clearData());
        dispatch(updateSearch(true));
    }

    const handleSearch = () => {
        dispatch(searchClicked(true));
        dispatch(searchTriggered(!searchTriggeredValue));
    }

    return (
        <>
            {loading && <Spinner />}
            <>
                {isSmall && <div style={{ paddingBottom: '24px' }}>
                    {PAExtensions_Header}
                </div>}
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <Autocomplete
                            size="small"
                            options={runDate}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Run Date"
                                    required
                                    helperText="Required"
                                    fullWidth
                                />
                            )}
                            onChange={(e) => handleChange('runId', e)}
                            value={data.runId}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <Autocomplete
                            size="small"
                            options={seqNo}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Seq No"
                                    required
                                    helperText="Required"
                                    fullWidth
                                />
                            )}
                            onChange={(e) => handleChange('seqNo', e)}
                            value={data.seqNo}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <Autocomplete
                            size="small"
                            options={carrier}
                            renderInput={(params) => (
                                <TextField {...params} label="Carrier" />
                            )}
                            onChange={(e) => handleChange('carrier', e)}
                            value={data.carrier}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <TextField
                            id="accountInput"
                            label="Account"
                            variant="outlined"
                            size="small"
                            onChange={(e) => handleChange('accountInput', e)}
                            value={data.accountInput}
                            error={inputError.accountInput}
                            helperText={inputError.accountInput ? InvalidMessage : ''}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <TextField
                            id="groupInput"
                            label="Group"
                            variant="outlined"
                            size="small"
                            onChange={(e) => handleChange('groupInput', e)}
                            value={data.groupInput}
                            error={inputError.groupInput}
                            helperText={inputError.groupInput ? InvalidMessage : ''}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <TextField
                            id="memberInput"
                            label="Member"
                            variant="outlined"
                            size="small"
                            onChange={(e) => handleChange('memberInput', e)}
                            value={data.memberInput}
                            error={inputError.memberInput}
                            helperText={inputError.memberInput ? InvalidMessage : ''}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 1.714285714285714, lg: 1.714285714285714, xl: 1.714285714285714 }}>
                        <TextField
                            id="gpiInput"
                            label="GPI"
                            variant="outlined"
                            size="small"
                            onChange={(e) => handleChange('gpiInput', e)}
                            value={data.gpiInput}
                            error={inputError.gpiInput}
                            helperText={inputError.gpiInput ? InvalidMessage : ''}
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} sx={{ justifyContent: 'center', paddingTop: '12px' }}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleClear}
                        style={{ color: 'var(--primary-font-color)' }}
                        endIcon={<Clear />}
                    >
                        Clear
                    </Button>
                    <Button
                        variant={!isSearched ? "contained" : "outlined"}
                        style={isSearched ? { color: 'var(--primary-font-color)' } : undefined}
                        size="small"
                        onClick={handleReset}
                        endIcon={<Refresh />}
                        disabled={!isSearched}
                    >
                        Reset
                    </Button>
                    <Button
                        variant={(search || hasAnyError) ? "contained" : "contained"}
                        size="large"
                        onClick={handleSearch}
                        endIcon={<Search />}
                        style={(!search && !hasAnyError) ? { color: 'var(--primary-font-color)', background: 'var(--primary-color)', border: '1px solid var(--primary-font-color)' } : undefined}
                        disabled={search || hasAnyError}
                    >
                        Search
                    </Button>
                </Grid>
                {isSearched && <Table />}
            </>
            {/* } */}
        </>
    )
}

export default PAExtensions